import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { MediaService } from '../../../../services/media.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { WorkflowDialogContent } from '../../../workflow.dialog';

export class EditImageSettingsData {
    MediaSource: string;
    FileName: string;
    ReadFileNameFromStatus = false;
    NewHeight = 100;
    NewWidth = 100;
    KeepRatio = true;
    EditOriginal = false;
    Suffix = 'thumbnail';
}

export class EditImageSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new EditImageSettingsData();
    }
}

@Component({
    selector: 'wf-editimage-settings',
    templateUrl: './editimage.settings.html',
    styleUrls: ['./editimage.settings.css']
})
export class EditImageSettings extends WorkflowDialogContent {
    Data = new EditImageSettingsData();
    MediaSources = [];

    static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'editImageWFModule';
        reg.Caption = '@@Bild bearbeiten';
        reg.GroupID = 'wfActions';
        reg.Index = 60;
        reg.SettingsControl = EditImageSettings;
        reg.SettingsTypeHelper = new EditImageSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: MediaService) {
        super();
    }

    ngOnInit(): void {
        this.service.Get().subscribe(r => {
            if (r) {
                this.MediaSources = r;
            }
        });
    }

    initialize(data: any) {
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, EditImageSettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}
